__turbopack_context__.v({
  "down_icon": "StationButton-module-scss-module__O1WwVG__down_icon",
  "station_button": "StationButton-module-scss-module__O1WwVG__station_button",
  "up_icon": "StationButton-module-scss-module__O1WwVG__up_icon",
});
